import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AreYouSureGuard } from '@app/core/are-you-sure-guard/are-you-sure.guard';
import { BusinessesComponent } from './pages/businesses/businesses.component';
import { EditBusinessComponent } from './pages/edit-business/edit-business.component';
import { NewBusinessComponent } from './pages/new-business/new-business.component';
import { FullScreenModalComponent } from '@app/shared/layouts/full-screen-modal/full-screen-modal.component';
import { ProfitAndLossComponent } from './pages/profit-and-loss/profit-and-loss.component';
import { AdjustmentsComponent } from './pages/adjustments/adjustments.component';
import { TransactionsListComponent } from './pages/transactions-list/transactions-list.component';
import { TransactionAddComponent } from './pages/transaction-add/transaction-add.component';
import { TransactionEditComponent } from './pages/transaction-edit/transaction-edit.component';
import { CanSeeMyBusinessGuard } from './guards/can-see-my-business.guard';
import { TransactionsImportComponent } from './pages/transactions-import/transactions-import.component';
import { NewAccountingWizardComponent } from '@app/modules/my-business/components/new-accounting-wizard/new-accounting-wizard.component';

const routes: Routes = [
  {
    path: 'businesses',
    component: BusinessesComponent,
    canActivate: [CanSeeMyBusinessGuard],

    data: {
      title: 'Businesses',
      redirectPath: '/demo/my-business',
    },
  },
  {
    path: 'businesses/new',
    component: FullScreenModalComponent,
    data: {
      width: '920px',
      title: 'New Business',
      closeLink: '/operations/my-business/businesses',
    },
    children: [
      {
        path: '',
        component: NewBusinessComponent,
        canDeactivate: [AreYouSureGuard],
        data: {
          title: 'New Business',
        },
      },
    ],
  },
  {
    path: 'businesses/:uuid',
    component: EditBusinessComponent,
    data: {
      title: 'Business',
    },
  },
  { path: 'reports/profit-and-loss', component: ProfitAndLossComponent, data: { title: 'Profit and Loss Report' } },
  { path: 'transactions', component: TransactionsListComponent, data: { title: 'Transactions' } },
  { path: 'transactions/add', component: TransactionAddComponent, data: { title: 'New Transaction' } },
  {
    path: 'transactions/import',
    component: TransactionsImportComponent,
    data: {
      title: 'Import Transactions',
    },
  },
  {
    path: 'transactions/:id/:recurring',
    component: TransactionEditComponent,
    data: { title: 'Edit Recurring Transaction' },
  },
  { path: 'transactions/:id', component: TransactionEditComponent, data: { title: 'Edit Transaction' } },
  { path: 'adjustments', component: AdjustmentsComponent, data: { title: 'Adjustments' } },
  {
    path: 'accounting/:id',
    component: FullScreenModalComponent,
    data: {
      title: 'New Accounting Connection',
      closeLink: '/operations/my-business/businesses',
    },
    children: [
      {
        path: '',
        component: NewAccountingWizardComponent,
        canDeactivate: [AreYouSureGuard],
        data: {
          title: 'New Accounting Connection',
        },
      },
    ],
  },
  { path: '', redirectTo: 'businesses', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MyBusinessRoutingModule {}
